import { ThemeEvents } from '@theme/events';
import { sectionRenderer } from '@theme/section-renderer';

/**
 * <spend-ladder> — re-renders its section on every cart change so the tier
 * progress follows quick-adds without a page reload. All markup and math live
 * in sections/spend-ladder.liquid. It fetches its own section because Horizon's
 * cart requests only bundle cart-items-component sections into the response.
 */
class SpendLadder extends HTMLElement {
  connectedCallback() {
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  #onCartUpdate = () => {
    if (this.dataset.sectionId) sectionRenderer.renderSection(this.dataset.sectionId, { cache: false });
  };
}

if (!customElements.get('spend-ladder')) customElements.define('spend-ladder', SpendLadder);
